export default __webpack_public_path__ + "static/media/ins_200_sal.83455456.jpg";